export const COREABI = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountBaseIn",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountRoundIn",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountBaseOut",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountRoundOut",
                type: "uint128",
            },
        ],
        name: "Swap",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint128",
                name: "_balance",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_maxBaseIn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_roundOut",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "buyExactRoundsWithBases",
        outputs: [
            {
                internalType: "uint128",
                name: "_baseInFinal",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_roundOutFinal",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_baseIn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_minRoundOut",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "buyRoundsWithExactBases",
        outputs: [
            {
                internalType: "uint128",
                name: "_baseInFinal",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_roundOutFinal",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "getBaseToken",
        outputs: [
            {
                internalType: "address",
                name: "_baseToken",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "getReserves",
        outputs: [
            {
                internalType: "uint128",
                name: "_baseReserve",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_roundReserve",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_roundOut",
                type: "uint128",
            },
        ],
        name: "quoteBuyExactRounds",
        outputs: [
            {
                internalType: "uint128",
                name: "_baseIn",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_baseIn",
                type: "uint128",
            },
        ],
        name: "quoteBuyWithExactBases",
        outputs: [
            {
                internalType: "uint128",
                name: "_roundOut",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_roundIn",
                type: "uint128",
            },
        ],
        name: "quoteSellExactRounds",
        outputs: [
            {
                internalType: "uint128",
                name: "_baseOut",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_baseOut",
                type: "uint128",
            },
        ],
        name: "quoteSellWithExactBases",
        outputs: [
            {
                internalType: "uint128",
                name: "_roundIn",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_roundIn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_minBaseOut",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "sellExactRoundsWithBases",
        outputs: [
            {
                internalType: "uint128",
                name: "_roundInFinal",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_baseOutFinal",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_maxRoundIn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_baseOut",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "sellRoundsWithExactBases",
        outputs: [
            {
                internalType: "uint128",
                name: "_roundInFinal",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_baseOutFinal",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_baseToken",
                type: "address",
            },
        ],
        name: "withdrawFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amount",
                type: "uint128",
            },
        ],
        name: "ClaimPairReward",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_userAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amount",
                type: "uint128",
            },
        ],
        name: "ClaimUserReward",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "claimPairReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "claimUserReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_baseToken",
                type: "address",
            },
        ],
        name: "getDistPoolInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "_rewardParameter",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_gasReward",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "getPairReward",
        outputs: [
            {
                internalType: "uint128",
                name: "_amount",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRewardEpoch",
        outputs: [
            {
                internalType: "uint256",
                name: "_rewardEpoch",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_userAddress",
                type: "address",
            },
        ],
        name: "getUserReward",
        outputs: [
            {
                internalType: "uint128",
                name: "_amount",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountOut",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountToRHolderPR",
                type: "uint128",
            },
        ],
        name: "Accept",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_expiry",
                type: "uint128",
            },
        ],
        name: "Bid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
        ],
        name: "Delist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_nftAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_version",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "_tags",
                type: "string[]",
            },
        ],
        name: "List",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountOut",
                type: "uint128",
            },
        ],
        name: "Refund",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amountOut",
                type: "uint128",
            },
        ],
        name: "Unbid",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_minAmountOut",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "acceptMetaNftBid",
        outputs: [
            {
                internalType: "uint128",
                name: "_amountOut",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_minAmountOut",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "acceptNftBid",
        outputs: [
            {
                internalType: "uint128",
                name: "_amountOut",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_amountToRHolderPR",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "bidMetaNft",
        outputs: [
            {
                internalType: "uint64",
                name: "_expiry",
                type: "uint64",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "bidNft",
        outputs: [
            {
                internalType: "uint64",
                name: "_expiry",
                type: "uint64",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_maxAmountIn",
                type: "uint128",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "delist",
        outputs: [
            {
                internalType: "uint128",
                name: "_amountInFinal",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_nftAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "_initPrice",
                type: "uint128",
            },
            {
                internalType: "address",
                name: "_baseToken",
                type: "address",
            },
            {
                internalType: "string[]",
                name: "_tags",
                type: "string[]",
            },
            {
                internalType: "bytes32",
                name: "_descriptionHash",
                type: "bytes32",
            },
        ],
        name: "list",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "pollMetaNftBid",
        outputs: [
            {
                internalType: "address",
                name: "_bidder",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "pollNftBid",
        outputs: [
            {
                internalType: "address",
                name: "_bidder",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "quoteDelist",
        outputs: [
            {
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "quoteMetaNft",
        outputs: [
            {
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "quoteNft",
        outputs: [
            {
                internalType: "uint128",
                name: "_amountIn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_amountToMNftHolder",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_amountToRHolderPR",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "quoteRefundRoundTokens",
        outputs: [
            {
                internalType: "uint128",
                name: "_price",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "refundRoundTokens",
        outputs: [
            {
                internalType: "uint128",
                name: "_amountOutFinal",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "unbidMetaNft",
        outputs: [
            {
                internalType: "uint128",
                name: "_amountOut",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "_deadline",
                type: "uint64",
            },
        ],
        name: "unbidNft",
        outputs: [
            {
                internalType: "uint128",
                name: "_amountOut",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "_descriptionHash",
                type: "bytes32",
            },
        ],
        name: "updateDescriptionHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_baseToken",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "_rewardParameter",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "_gasReward",
                type: "uint128",
            },
        ],
        name: "createPool",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "halveRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_baseFeeNumerator",
                type: "uint32",
            },
        ],
        name: "setBaseFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_bidTimeout",
                type: "uint32",
            },
        ],
        name: "setBidTimeout",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_baseToken",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "_gasReward",
                type: "uint128",
            },
        ],
        name: "setGasReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_nftFeeNumerator",
                type: "uint32",
            },
        ],
        name: "setNftFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_rewardEpoch",
                type: "uint32",
            },
        ],
        name: "setRewardEpoch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_baseToken",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "_rewardParameter",
                type: "uint128",
            },
        ],
        name: "setRewardParameter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_roundFeeNumerator",
                type: "uint32",
            },
        ],
        name: "setRoundFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenA",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tokenB",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_value",
                type: "uint32",
            },
        ],
        name: "setUniV3ExtraRewardParam",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getBaseFee",
        outputs: [
            {
                internalType: "uint32",
                name: "_baseFeeNumerator",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBidTimeout",
        outputs: [
            {
                internalType: "uint32",
                name: "_bidTimeout",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_baseToken",
                type: "address",
            },
        ],
        name: "getCumulativeFees",
        outputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_nftAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
        ],
        name: "getMetaNftId",
        outputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_nftAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "_version",
                type: "uint32",
            },
        ],
        name: "getMetaNftId",
        outputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getNftFee",
        outputs: [
            {
                internalType: "uint32",
                name: "_nftFeeNumerator",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
        ],
        name: "getPairInfo",
        outputs: [
            {
                internalType: "address",
                name: "_nftAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "_version",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_descriptionHash",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRoundFee",
        outputs: [
            {
                internalType: "uint32",
                name: "_roundFeeNumerator",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenA",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tokenB",
                type: "address",
            },
        ],
        name: "getUniV3ExtraRewardParam",
        outputs: [
            {
                internalType: "uint32",
                name: "_uniExtraRewardParam",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amount",
                type: "uint128",
            },
        ],
        name: "EarnPairReward",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_userAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_amount",
                type: "uint128",
            },
        ],
        name: "EarnUserReward",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_metaNftId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_value",
                type: "uint128",
            },
        ],
        name: "Transfer",
        type: "event",
    },
];
